import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b1c8396"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-menu__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mt-1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M7.701 7.835c-.329 0-.121-.124-.874-.346L1.12 2.18C.64 1.557.641.812 1.124.353 1.606.104 2.386.104 2.867.357l4.834 4.634L12.534.357c.606-.253 1.261-.253 1.744-.004.481.459.483 1.204.002 1.827L8.574 7.489c-.232.222-.294.346-.873.346z"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "user-menu__dropdown"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user-menu__content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mt-1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0b0d20",
    d: "M7.701 7.835c-.329 0-.121-.124-.874-.346L1.12 2.18C.64 1.557.641.812 1.124.353 1.606.104 2.386.104 2.867.357l4.834 4.634L12.534.357c.606-.253 1.261-.253 1.744-.004.481.459.483 1.204.002 1.827L8.574 7.489c-.232.222-.294.346-.873.346z"
  })
], -1))
const _hoisted_8 = { class: "user-menu__mobile" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "user-menu__mobile-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#2457ca",
    d: "M.999 11.839c1.157 0 2.267-.186 3.302-.528a.943.943 0 0 1 .944.222l2.036 2.035a13.934 13.934 0 0 0 6.098-6.088l-2.035-2.044a.905.905 0 0 1-.232-.935c.342-1.036.527-2.146.527-3.303a.93.93 0 0 1 .926-.926h3.238a.93.93 0 0 1 .926.926c0 8.688-7.042 15.73-15.73 15.73a.928.928 0 0 1-.925-.926v-3.238c0-.509.415-.925.925-.925z"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "user-menu__limited"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-menu__limited-title" }, "محدودیت خرید:", -1))
const _hoisted_12 = {
  key: 0,
  class: "user-menu__limited-content"
}
const _hoisted_13 = {
  key: 1,
  class: "user-menu__limited-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_button = _resolveComponent("form-button")!
  const _component_unlimited = _resolveComponent("unlimited")!
  const _component_logout = _resolveComponent("logout")!
  const _component_account_activation_modal = _resolveComponent("account-activation-modal")!
  const _component_resolving_limitation_modal = _resolveComponent("resolving-limitation-modal")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = true)),
      class: _normalizeClass([
      'user-menu',
      _ctx.user?.item.status === 'unverified'
        ? 'user-menu--unverified'
        : 'user-menu--verified',
    ])
    }, [
      _createElementVNode("img", {
        class: "user-menu__avatar",
        width: "41",
        height: "41",
        src: _ctx.user.item.avatar,
        alt: "avatar"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(`${_ctx.user.item.name} ${_ctx.user.item.lastname}`), 1),
      _hoisted_3,
      _createVNode(_Transition, {
        "enter-active-class": "animate__animated animate__fadeIn",
        "leave-active-class": "animate__animated animate__fadeOut",
        class: "animate__faster",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass([
            'user-menu',
            _ctx.user?.item.status === 'unverified'
              ? 'user-menu--unverified'
              : 'user-menu--verified',
          ])
                }, [
                  _createElementVNode("img", {
                    class: "user-menu__avatar",
                    width: "41",
                    height: "41",
                    src: _ctx.user.item.avatar,
                    alt: "avatar"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(`${_ctx.user.item.name} ${_ctx.user.item.lastname}`), 1),
                  _hoisted_7
                ], 2),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(`${_ctx.user.item.mobile.slice(
              4,
              _ctx.user.item.mobile.length
            )} (${_ctx.user.item.mobile.slice(0, 4)})`) + " ", 1),
                  _hoisted_9
                ]),
                (
            _ctx.user.item.buy_limit_status === 'limited' ||
            _ctx.user.item.status === 'unverified'
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      (_ctx.user.item.status === 'unverified')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " حساب فعال نیست! "))
                        : (_ctx.user.item.buy_limit_status === 'limited')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, " هر ۲۴ ساعت " + _toDisplayString(_ctx.user.item.buy_limit) + " دلار ", 1))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user?.item.status === 'unverified')
                  ? (_openBlock(), _createBlock(_component_form_button, {
                      key: 1,
                      "full-width": "",
                      type: "button",
                      label: "فعال سازی حساب",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activationForm = true)),
                      class: "user-menu__button"
                    }))
                  : (
            _ctx.user?.item.verification_bottom === 'show' ||
            _ctx.user?.item.verification_bottom === 'show_and_inactive'
          )
                    ? (_openBlock(), _createBlock(_component_form_button, {
                        key: 2,
                        disabled: _ctx.isResolvingLimitationButtonDisabled,
                        "full-width": "",
                        label: 
            _ctx.isResolvingLimitationButtonDisabled
              ? 'رفع محدودیت خرید (درحال بررسی)'
              : 'رفع محدودیت خرید'
          ,
                        style: _normalizeStyle([_ctx.isResolvingLimitationButtonDisabled && { fontSize: '11px' }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resolvingLimitationForm = true)),
                        class: "user-menu__button"
                      }, null, 8, ["disabled", "label", "style"]))
                    : (_openBlock(), _createBlock(_component_unlimited, { key: 3 })),
                _createVNode(_component_logout)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)), [
      [_directive_click_away, _ctx.onClickOutside]
    ]),
    _createVNode(_component_account_activation_modal, {
      modelValue: _ctx.activationForm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activationForm) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_resolving_limitation_modal, {
      modelValue: _ctx.resolvingLimitationForm,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resolvingLimitationForm) = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}